import {
    Background,
    BackgroundColor,
    Container,
    Spacer,
    SpacerVariant,
    backgroundGreyScaleColorsOptions,
    spacerOptionsAll,
} from "../components/layout"
import { Repeater, types } from "react-bricks/frontend"

import AccountDeletionForm from "../../components-v2/new/form/account-deletion"
import BiathlonForm from "../../components-v2/new/form/biathlon"
import CancellationPolicyForm from "../../components-v2/new/form/cancellation-policy"
import Contact from "../../components-v2/new/form/contact"
import ContactPartnership from "../../components-v2/new/form/contact-partnership"
import ContactPartnershipShort from "../../components-v2/new/form/contact-partnership-short"
import Coupon from "../../components-v2/new/form/coupon"
import FirmenGesundheitForm from "../../components-v2/new/form/firmengesundheit"
import LavitaCupForm from "../../components-v2/new/form/lavita-cup"
import NewsletterSurveyForm from "../../components-v2/new/form/newsletter-survey"
import React from "react"
import Whatsapp from "../../components-v2/new/form/whatsapp"

const Forms = {
    empty: null,
    contact: (
        <Container>
            <Contact />
        </Container>
    ),
    voucher: (
        <Container>
            <Coupon />
        </Container>
    ),
    inlineVoucher: <Coupon inline />,
    biathlon: (
        <Container>
            <BiathlonForm />
        </Container>
    ),
    company_health: (
        <>
            <Container>
                <FirmenGesundheitForm />
            </Container>
        </>
    ),
    account_deletion: (
        <Container>
            <AccountDeletionForm />
        </Container>
    ),
    contact_partnership: (
        <Container>
            <ContactPartnership />
        </Container>
    ),
    contact_lavitacup: (
        <Container>
            <LavitaCupForm />
        </Container>
    ),
    whatsapp: (
        <Container>
            <Whatsapp />
        </Container>
    ),
    newsletter_survey: (
        <Container>
            <NewsletterSurveyForm />
        </Container>
    ),
    contact_partnership_short: (
        <Container>
            <ContactPartnershipShort />
        </Container>
    ),
    selftest: <Repeater propName="selftestForm" />,
    cancellation_policy: (
        <Container>
            <CancellationPolicyForm />
        </Container>
    ),
}

interface FormProps {
    form: keyof typeof Forms
    index?: number
    background: { color: BackgroundColor } | BackgroundColor
    spacerTop?: SpacerVariant
    spacerBottom?: SpacerVariant
}

const Form: types.Brick<FormProps> = ({ form, index, background = BackgroundColor.Grey, spacerTop, spacerBottom }) => {
    const bgColor = typeof background === "object" ? background.color : background

    return (
        <Background color={bgColor} key={index}>
            <Spacer variant={spacerTop} />
            {Forms[form] || null}
            <Spacer variant={spacerBottom} />
        </Background>
    )
}

Form.schema = {
    name: "Forms",
    label: "Forms",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/Forms.png`,
    repeaterItems: [
        {
            name: "selftestForm",
            items: [
                {
                    type: "Selftest",
                    label: "Selftest Form",
                    min: 1,
                    max: 1,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            name: "form",
            label: "Form",
            type: types.SideEditPropType.Select,
            selectOptions: {
                display: types.OptionsDisplay.Select,
                options: [
                    { value: "empty", label: "Choose a form" },
                    { value: "contact", label: "Contact Form" },
                    { value: "voucher", label: "Voucher Form" },
                    { value: "inlineVoucher", label: "Inline Voucher Form" },
                    { value: "biathlon", label: "Biathlon Form" },
                    { value: "company_health", label: "Company Health Form" },
                    { value: "account_deletion", label: "Account Deletion Form" },
                    { value: "contact_partnership", label: "Contact Partnership Form" },
                    { value: "contact_lavitacup", label: "Contact Lavita Cup Form" },
                    { value: "whatsapp", label: "Whatsapp Form" },
                    { value: "newsletter_survey", label: "Newsletter Survey Form" },
                    { value: "contact_partnership_short", label: "Contact Partnership Short Form" },
                    { value: "selftest", label: "Selftest Form" },
                    { value: "cancellation_policy", label: "Cancellation Policy Form" },
                ],
            },
        },
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                display: types.OptionsDisplay.Color,
                options: backgroundGreyScaleColorsOptions,
            },
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
            ],
        },
    ],
}

export default Form
